import axios from 'axios';
import NProgress from 'nprogress';
import router from '@/router';
import store from "../store";

NProgress.configure({ showSpinner: false });

axios.defaults.baseURL = `${process.env.VUE_APP_API}/`;

// Intercept the request to make sure the token is injected into the header.
axios.interceptors.request.use(config => {
  config.headers.Authorization = `${localStorage.getItem('token')}`;
  NProgress.start();
  return config;
});

axios.interceptors.response.use(
  response => {
    if (response.statusCode === 403) {
      router.push('/login');
    }

    NProgress.done();
    return response;
  },
  error => {
    if (error.response && error.response.status === 403) {
      localStorage.removeItem('token');
      store.commit('logout');
      router.push('/login');
    }

    NProgress.done();
    return Promise.reject(error);
  }
);

const http = {
  post: (url, data) => axios.post(url, data),
  put: (url, data) => axios.put(url, data),
  get: url => axios.get(url),
  delete: (url, data) => axios.delete(url, data),
  getDropzoneConfig: (url, method, options) =>
    Object.assign(options, {
      url: `${process.env.VUE_APP_API}/v1${url}`,
      headers: { Authorization: localStorage.getItem('token') },
      method
  }),
};

export default http;
